// extracted by mini-css-extract-plugin
export default {"spectacleDetailVideo":"SpectacleDetailVideo_spectacleDetailVideo__-5R25","videoLayer":"SpectacleDetailVideo_videoLayer__ax3Hz"};